import { BASE_URL } from "../Environment/config"
import { httpClient } from "../Http/client"

export const updatePasswordHandler = async(userData) => {
    return await httpClient.put(`${BASE_URL}/profiles/customer`, userData)
}